import React from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";

import { Business, Home, Person, Router } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { Tooltip } from "@mui/material";

function SidebarLayout() {
  const navigate = useNavigate();

  let theme = useTheme();

  return (
    <Sidebar
      defaultCollapsed={localStorage.getItem("sidebarCollapsed") === "true"}
      className="app"
      backgroundColor={
        theme.palette.mode === "dark" ? "#191B1F" : theme.palette.primary.main
      }
      color={theme.palette.mode === "dark" ? "#8ba1b7" : "#fff"}
    >
      <Menu
        menuItemStyles={{
          button: ({ level, active, disabled }) => {
            if (level === 0) {
              return {
                color: disabled
                  ? "#eee"
                  : theme.palette.mode === "dark"
                  ? "#8ba1b7"
                  : "#fff",
                backgroundColor: active ? "#fff" : undefined,
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "dark" ? "#8ba1b7" : "#fff",
                  color:
                    theme.palette.mode === "dark"
                      ? "#fff"
                      : theme.palette.primary.main,
                },
              };
            }
          },
        }}
      >
        <Tooltip title="Home" placement="right">
          <div>
            <MenuItem onClick={() => navigate("/")} icon={<Home />}>
              Home
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip title="Users" placement="right">
          <div>
            <MenuItem onClick={() => navigate("/user")} icon={<Person />}>
              Users
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip title="Devices" placement="right">
          <div>
            <MenuItem onClick={() => navigate("/device")} icon={<Router />}>
              Devices
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip title="Device Brands" placement="right">
          <div>
            <MenuItem
              onClick={() => navigate("/device/brand")}
              icon={<Router />}
            >
              Device Brands
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip title="Organisations" placement="right">
          <div>
            <MenuItem
              onClick={() => navigate("/organisation")}
              icon={<Business />}
            >
              Organisations
            </MenuItem>
          </div>
        </Tooltip>
        <Tooltip title="LNS Management" placement="right">
          <div>
            <MenuItem onClick={() => navigate("/lns")} icon={<Router />}>
              LNS Management
            </MenuItem>
          </div>
        </Tooltip>
      </Menu>
    </Sidebar>
  );
}

export default SidebarLayout;
